const BaseView = require('./logo-type');

module.exports = BaseView.extend({
  type: 'qrcode',
  template: require('./qrcode-type.hbs'),
  ElementListView: require('./element-list/qrcode-view'),
  basicHide: ['qrcode_add', 'qrcode_replace', 'qrcode_position', 'qrcode_colour', 'qrcode_z_index'],

  getTypeFilterRegex: function () {
    return /^qrcode_/;
  },

  renderDisabled: function () {
    this._renderColorDisabled();
    BaseView.prototype.renderDisabled.apply(this, arguments);
  },

  initLibraryFolders: async function (type) {
    // this function is not implemented on purpose
  },

  selectSpecifyFolder: function () {
    // this function is not implemented on purpose
  },

  selectSpecifySource: function () {
    // this function is not implemented on purpose
  },

  _renderColorDisabled: function () {
    const replaceColorInput = document.querySelector('#element-restrictions-color-content');
    const replaceColorSubInput = document.querySelector('#element-restrictions-colors');
    const replaceColorPaletteSubInput = document.querySelector('#element-restrictions-colors-library');
    const isReplaceOn = this.getOptionValue($(replaceColorInput));
    const isReplaceSpecifiedColorOn = this.getOptionValue($(replaceColorSubInput));
    const isReplaceSpecifiedPaletteOn = this.getOptionValue($(replaceColorPaletteSubInput));

    if (replaceColorInput) {
      this.el.querySelector('div[data-name="colors"]').classList.toggle('hidden', !isReplaceOn);
      this.el.querySelector('div[data-name="colors-library"]').classList.toggle('hidden', !isReplaceOn);

      if (replaceColorSubInput) {
        this.el.querySelector('.color-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedColorOn));
      }

      if (replaceColorPaletteSubInput) {
        this.el.querySelector('.palette-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedPaletteOn));
      }
    }
    this.recalculateSectionHeight(replaceColorInput);
  },

  _toggleColors: function (value) {
    const colors = this.el.querySelector('#element-restrictions-colors');
    const colorsLibrary = this.el.querySelector('#element-restrictions-colors-library');

    this.el.querySelector('div[data-name="colors"]').classList.toggle('hidden', !value);
    this.el.querySelector('div[data-name="colors-library"]').classList.toggle('hidden', !value);

    if (value) return;

    this.el.querySelector('.color-replacement-options').classList.toggle('hidden', true);
    this.el.querySelector('.palette-replacement-options').classList.toggle('hidden', true);
    colors.checked = false;
    colorsLibrary.checked = false;
    this.colorsListView.removeAllElement();
    this.onSectionChange(colors);
    this.onSectionChange(colorsLibrary);
  }
});
